
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { isCustomPlateCode } from "@common/src/utils/tools";
const app = namespace("app");
const base = namespace("base");
const customer = namespace("customer");
const user = namespace("user");

@Component({
  inheritAttrs: false,
  model: {
    prop: "plateCode",
    event: "input"
  }
})
export default class InputCarNum extends Vue {
  @base.Action getDictionaryList;
  @customer.Action getCustomerList;
  @app.State country;
  @user.State defaultPlateProvince;
  @Prop({ default: "" })
  plateCode: string;
  @Prop({ default: 1 }) // 1：输入框 2：搜索下拉框
  mode: number;
  @Prop({ default: true }) // 1：输入框 2：搜索下拉框
  showCustomCheckbox: boolean;
  carNum: string = "";
  carNumList: any = [];
  plateNum: string = "";
  plateCodeOptions: any[] = [];
  customState = false;
  created() {
    this.init();
  }
  init() {
    this.getDictionaryList("plate_province").then(data => {
      this.carNumList = data;
      if (!this.$provinceValue && this.carNumList[0]) {
        this.$emit("input", (this.defaultPlateProvince || this.carNumList[0].dataValue) + this.$plateValue);
      }
    });
  }
  searchKey: string = "";
  remoteMethod(val) {
    if (val) {
      this.searchKey = val;
      this.updateValue(val, "input");
      this.getCustomerList({
        pageSize: 20,
        pageNum: 1,
        searchKey: this.$provinceValue + val
      }).then(data => {
        this.plateCodeOptions = (data.data?.list || []).map(item => {
          item.plateCode = item.plateCode.slice(1);
          return item;
        });
      });
    } else {
      this.searchKey = "";
      this.plateCodeOptions = [];
    }
  }
  updateValue(val, type) {
    val = val.toUpperCase();
    if (type === "input") {
      if (this.customState) {
        this.$emit("input", val);
      } else {
        this.$emit("input", this.$provinceValue + val);
      }
    } else {
      this.$emit("input", val + this.$plateValue);
      this.$emit("change", val + this.plateNum);
    }
  }
  handleBlur() {
    setTimeout(() => {
      this.plateNum = this.searchKey;
      this.emitUpdate("all");
    }, 50);
  }
  handleChooseVehicle() {
    this.emitUpdate("all");
  }
  emitUpdate(type) {
    if (type === "input") {
      this.$emit("input", this.$provinceValue + this.plateNum);
    } else if (type === "change") {
      this.$emit("change", this.$provinceValue + this.plateNum);
    } else {
      this.$emit("input", this.$provinceValue + this.plateNum);
      this.$emit("change", this.$provinceValue + this.plateNum);
    }
  }
  get $provinceValue() {
    return this.plateCode ? this.plateCode.substring(0, 1) : this.defaultPlateProvince;
  }
  get $plateValue() {
    return this.plateCode ? this.plateCode.slice(1) : "";
  }
  @Watch("plateCode", { immediate: true })
  plateCodeChange(val) {
    console.log("plateCode watch", val);
    if (val) {
      this.checkCustomState();
      if (this.customState) {
        this.plateNum = val;
      } else {
        this.plateNum = val.slice(1);
        this.searchKey = val.slice(1);
        this.plateCodeOptions = [
          {
            vehicleCode: "defineKey",
            plateCode: val.slice(1)
          }
        ];
      }
    } else {
      this.plateNum = "";
      this.plateCodeOptions = [];
    }
  }
  checkCustomState() {
    if (this.plateCode && isCustomPlateCode(this.plateCode)) {
      this.customState = true;
    } else {
      this.customState = false;
    }
  }
  handleCustomChange(val) {
    if (!val) {
      this.$emit("input", this.defaultPlateProvince + this.plateNum);
      this.$emit("change", this.defaultPlateProvince + this.plateNum);
    } else {
      this.$emit("input", this.plateNum);
      this.$emit("change", this.plateNum);
    }
  }
}
